var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('StatusIcon',{attrs:{"item":_vm.item,"type":_vm.statusIconTypes.systemUser}}),(_vm.item.activated)?_c('FormattedDate',{class:_vm.$style.text,attrs:{"item":_vm.item,"type":_vm.formattedDateTypes.userPasswordExpiry}}):_c('p',{class:_vm.$style.text},[_vm._v(" Password pending ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }